module.exports = __webpack_public_path__ + "img/201219_TUTORIAL-04b.770ed7c1.jpg";